import React from "react";

import { format } from "date-fns";

import { Box, Text, Flex } from "@chakra-ui/react";

import { IconeDownload } from "../../IconeDownload";
import Group from "../../../pages/ServicosAcolhimento/Visualizar/Group";
import Table from "../../../pages/ServicosAcolhimento/FamiliaAcolhedora/Table";
import { cpf } from "../../../utils/masks";
export const FamiliaAcolhedora = ({ data }) => {
  const columns = [
    {
      Header: "Nome",
      accessor: "nome",
      sortType: (rowA, rowB, id, desc) => {
        let nameA = rowA.original.nome;
        let nameB = rowB.original.nome;

        return nameA.localeCompare(nameB, "pt-BR");
      },
      Cell: (props) => {
        return <Text>{props.value}</Text>;
      },
    },
    {
      Header: "CPF",
      accessor: "cpf",
      Cell: (props) => {
        return (
          <Text whiteSpace="nowrap">
            {props.value ? cpf(`${props.value}`) : ""}
          </Text>
        );
      },
    },
    {
      Header: "Data de Nascimento",
      accessor: "dataNascimento",
      Cell: (props) => {
        const formattedDate = props.value
          ? format(props.value, "dd/MM/yyyy")
          : "";
        return <Text>{formattedDate}</Text>;
      },
    },
    {
      Header: "Gênero",
      accessor: "genero",
      sortType: (rowA, rowB, id, desc) => {
        let nameA = rowA.original.genero.genero;
        let nameB = rowB.original.genero.genero;

        return nameA.localeCompare(nameB, "pt-BR");
      },
      Cell: (props) => {
        return <Text>{props.value.genero}</Text>;
      },
    },
    {
      Header: "Bairro",
      accessor: "bairro",
      sortType: (rowA, rowB, id, desc) => {
        let nameA = rowA.original.bairro.nomeBairro;
        let nameB = rowB.original.bairro.nomeBairro;

        return nameA.localeCompare(nameB, "pt-BR");
      },
      Cell: (props) => {
        return <Text>{props.value.nomeBairro}</Text>;
      },
    },
    {
      Header: "Crianças/Adolescentes acolhidos",
      accessor: (row) => {
        return row;
      },
      Cell: (props) => {
        return props.value.criancas.map((crianca, index) => {
          return (
            <React.Fragment key={index}>
              <span style={{ whiteSpace: "nowrap" }}>{crianca.nome}</span>
              {props.value.criancas.length > 1 && crianca.nome !== null ? (
                <hr />
              ) : (
                ""
              )}

              {props.value.length - 1 !== index && <br />}
            </React.Fragment>
          );
        });
      },
    },
    {
      Header: "Validade do termo de Guarda",
      accessor: (row) => {
        return row;
      },
      Cell: (props) => {
        return props.value.criancas.map((crianca, index) => {
          const formattedDate = crianca.dataValidateTermoGuarda
            ? format(crianca.dataValidateTermoGuarda, "dd/MM/yyyy")
            : "";

          return (
            <React.Fragment key={index}>
              {props.value.criancas.length > 1 &&
              crianca.dataValidateTermoGuarda !== null ? (
                <>
                  <span style={{ whiteSpace: "nowrap" }}>{formattedDate}</span>{" "}
                  <hr />
                </>
              ) : props.value.criancas.length === 1 &&
                crianca.dataValidateTermoGuarda !== null ? (
                <span style={{ whiteSpace: "nowrap" }}>{formattedDate}</span>
              ) : (
                <br />
              )}
              {props.value.length - 1 !== index && <br />}
            </React.Fragment>
          );
        });
      },
    },
    {
      Header: "Termo de Guarda",
      accessor: (row) => {
        return row;
      },
      Cell: (props) => {
        return props.value.criancas.map((crianca, index) => {
          return (
            <React.Fragment key={index}>
              {props.value.criancas.length > 1 &&
              crianca.termoGuarda === true ? (
                <>
                  <Flex mb={1} justifyContent={"center"}>
                    <IconeDownload />
                  </Flex>{" "}
                  <hr />{" "}
                </>
              ) : props.value.criancas.length === 1 &&
                crianca.termoGuarda === true ? (
                <Flex justifyContent={"center"} paddingTop="4">
                  <IconeDownload />
                </Flex>
              ) : (
                <br />
              )}

              {props.value.length - 1 !== index && <br />}
            </React.Fragment>
          );
        });
      },
    },
  ];

  return data ? (
    <Box display="block">
      <Box className="break-page">
        <Group
          bgColor="#DDEBEA"
          title="Acolhedores"
          mt="15px"
          py="12px"
          mtDivider="5px">
          <Table data={data} columns={columns} removePagination={true} />
        </Group>
      </Box>
    </Box>
  ) : (
    <Box display="block">
      <Group
        bgColor="#DDEBEA"
        title="Acolhedores"
        mt="15px"
        py="12px"
        mtDivider="5px"
      />
    </Box>
  );
};
